import React from "react";
const ErrorMessage = ({ navigation, navigationDispatcher, context }) => {
	if( navigation.error.message && navigation.error.context == context ) {
		return (
			<div className="full-width-block primary animated fadeIn">
				<div className="row">
					<div className="align-content vertical center pd-v split">
						<p className="white text-medium">{navigation.error.message}</p>
						<span className="icon icon-close white small" onClick={() => navigationDispatcher({type: "RESET_ERRORS" })}></span>
					</div>
				</div>
			</div>
		)
	} else {
		return null
	}
}
export default ErrorMessage
